<template>
    <div>
        <span class="tag year-tag rounded small d-inline-block pl-4 pr-4 mb-3 mr-2" v-bind:class="{'selected': year == selectedYear}" v-for="year in years" v-bind:key="year" v-on:click="selectYear(year)">{{ year }}</span>
        <!--<span class="small text-muted"><i class="fa fa-info-circle info-msg" v-bind:title="$t('chooseYearToSeeResults')"></i></span>-->
        <table class="table table-sm mb-0 table-responsive" v-show="financialIndicator && selectedYear">
            <tbody>
                <tr>
                    <td class="small font-weight-bold" width="100%">{{ $t("insuranceCompanies_BSA_064")}}</td>
                    <td class="small text-right">
                        <canvas ref="bsA_064" width="100" height="30"></canvas>
                    </td>
                </tr>
                <tr>
                    <td class="small font-weight-bold">{{ $t("insuranceCompanies_BSP_086")}}</td>
                    <td class="small text-right">
                        <canvas ref="bsP_086" width="100" height="30"></canvas>
                    </td>
                </tr>
                <tr>
                    <td class="small font-weight-bold">{{ $t("insuranceCompanies_BSP_087")}}</td>
                    <td class="small text-right">
                        <canvas ref="bsP_087" width="100" height="30"></canvas>
                    </td>
                </tr>
                <tr>
                    <td class="small font-weight-bold">{{ $t("insuranceCompanies_BSP_094")}}</td>
                    <td class="small text-right">
                        <canvas ref="bsP_094" width="100" height="30"></canvas>
                    </td>
                </tr>
                <tr>
                    <td class="small font-weight-bold">{{ $t("insuranceCompanies_BSP_100")}}</td>
                    <td class="small text-right">
                        <canvas ref="bsP_100" width="100" height="30"></canvas>
                    </td>
                </tr>
                <tr>
                    <td class="small font-weight-bold">{{ $t("insuranceCompanies_BSP_101")}}</td>
                    <td class="small text-right">
                        <canvas ref="bsP_101" width="100" height="30"></canvas>
                    </td>
                </tr>
                <tr>
                    <td class="small font-weight-bold">{{ $t("insuranceCompanies_BU_001")}}</td>
                    <td class="small text-right">
                        <canvas ref="bU_001" width="100" height="30"></canvas>
                    </td>
                </tr>
                <tr>
                    <td class="small font-weight-bold">{{ $t("insuranceCompanies_BU_010")}}</td>
                    <td class="small text-right">
                        <canvas ref="bU_010" width="100" height="30"></canvas>
                    </td>
                </tr>
                <tr>
                    <td class="small font-weight-bold">{{ $t("insuranceCompanies_BU_024")}}</td>
                    <td class="small text-right">
                        <canvas ref="bU_024" width="100" height="30"></canvas>
                    </td>
                </tr>
                <tr>
                    <td class="small font-weight-bold">{{ $t("insuranceCompanies_BU_025")}}</td>
                    <td class="small text-right">
                        <canvas ref="bU_025" width="100" height="30"></canvas>
                    </td>
                </tr>
                <tr>
                    <td class="small font-weight-bold">{{ $t("insuranceCompanies_BU_071")}}</td>
                    <td class="small text-right">
                        <canvas ref="bU_071" width="100" height="30"></canvas>
                    </td>
                </tr>
                <tr>
                    <td class="small font-weight-bold">{{ $t("insuranceCompanies_PPP_915")}}</td>
                    <td class="small text-right">
                        <canvas ref="ppP_915" width="100" height="30"></canvas>
                    </td>
                </tr>
            </tbody>

        </table>
        <div class="text-center small text-muted p-3" v-show="!financialIndicator && selectedYear">
            {{ $t("noResultsForSelectedYear")}}
        </div>
    </div>
</template>

<script>
    import { mapActions } from "vuex"

    export default {
        data() {
            return {
                financialIndicators: [],
                financialReports: [],
                selectedYear: null,
                selectedFinancialReportId: null,
                window: {
                    width: null
                }
            }
        },
        props: ["legalEntityId", "years"],
        methods: {
            ...mapActions(["fetchFinancialIndicators"]),
            formatNumber(value) {
                return new Intl.NumberFormat('de-DE').format(value);
            },
            selectYear(year) {
                this.selectedYear = year;
                //TODO: Log Search
                if (this.financialIndicator) {
                    for (let [key, value] of Object.entries(this.$refs)) {

                        let ctx = value.getContext("2d");
                        ctx.clearRect(0, 0, value.width, value.height); //Clear canvas before drawing new text into it
                        // ctx.font = "12px Roboto"; //setting font
                        ctx.font = "14px 'PT Sans Narrow'"; //setting font
                        ctx.textAlign = "end" //Aligning text

                        let width = 95;

                        ctx.fillText(this.formatNumber(this.financialIndicator[key]), width, 24); //Drawing text into canvas
                    }
                }
               
            },
            handleResize() {
                this.window.width = window.innerWidth;
            }
        },
        computed: {
            //years() {
            //    return this.financialIndicators.map(fi => fi.year).sort((a, b) => a - b);
            //},
            financialIndicator() {

                if (this.selectedYear == null)
                    return null;

                return this.financialIndicators.find(fi => fi.year == this.selectedYear);
            },
            windowWidth() {
                return this.window.width;
            }
        },
        created() {
            let searchObject = { legalEntityId: this.legalEntityId, searchType: 1 };

            this.fetchFinancialIndicators(searchObject).then((financialIndicators) => {
                this.financialIndicators = financialIndicators;
            });

            //window.addEventListener('resize', this.handleResize);
            //this.handleResize();
        }
    }

</script>

<style scoped>
    .tag {
        background-color: rgba(169, 169, 169, 0.5);
        color: var(--main-color);
        font-weight: bold;
        padding: 5px;
        cursor: pointer;
        transition: transform .2s;
    }

    .year-tag:hover {
        transform: scale(1.1);
    }

    .report-tag:hover {
        transform: scale(1.05);
    }

    .selected {
        background-color: var(--main-color);
        color: white;
    }

    td {
        vertical-align: middle;
    }

    .info-msg {
        font-size: 150%;
        position: absolute;
        top: 23px;
        cursor: pointer;
        transition: transform .2s;
    }

        .info-msg:hover {
            color: var(--main-color);
            transform: scale(1.1);
        }
</style>

